module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "RIckey_Townsend.ce458372.webp";